export const en = {
  // Header
  header: {
    title: "Simple And Fast Voice Replacement in Your Video, In Any Language!",
    subtitle: "🔥Pay only for results – just $0.099 per second.🔥"
  },

  // Steps
  steps: {
    uploadVideo: "Upload Video",
    selectLanguages: "Select Languages", 
    conversionResult: "Conversion & Result"
  },

  // Upload section
  upload: {
    dragAndDrop: "Drag and drop your video file here",
    orClickToSelect: "or click to select",
    supportedFormats: "Supported formats: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximum file size: 250 MB",
    maxDuration: "• Maximum duration : 15 min",
    processingTime: "• Processing will take 2 to 15 minutes depending on video resolution",
    chooseFile: "Choose File",
    selectedFile: "Selected file:",
    size: "Size:",
    fileTypeError: "Please select a video file",
    fileSizeError: "File size ({size} MB) exceeds the maximum limit of 250 MB",
    durationError: "Video duration ({duration} minutes) exceeds the maximum limit of 15 minutes",
    fileReadError: "Unable to read video file. Please try a different file."
  },

  // Language selection
  languages: {
    sourceAudioLanguage: "Source audio language",
    targetAudioLanguage: "Target audio language",
    selectLanguage: "Select language..."
  },

  // Language options
  languageOptions: {
    ru: "Russian",
    en: "English",
    es: "Spanish",
    fr: "French",
    de: "German",
    it: "Italian",
    pt: "Portuguese",
    pl: "Polish",
    zh: "Chinese",
    ja: "Japanese",
    ko: "Korean",
    bg: "Bulgarian",
    hr: "Croatian",
    cs: "Czech",
    da: "Danish",
    nl: "Dutch",
    et: "Estonian",
    fi: "Finnish",
    el: "Greek",
    hu: "Hungarian",
    ga: "Irish",
    lv: "Latvian",
    lt: "Lithuanian",
    mt: "Maltese",
    ro: "Romanian",
    sk: "Slovak",
    sl: "Slovenian",
    sv: "Swedish"
  },

  // Conversion
  conversion: {
    replaceAudio: "Replace Audio",
    uploadVideoAndSelectLanguages: "Upload a video and select languages to continue",
    fixValidationError: "Please fix the file validation error above",
    createSubtitles: "Create Subtitles",
    uploadVideoForSubtitles: "Upload a video to create subtitles",
    selectTranslationLanguage: "Select translation language"
  },

  // Demo video section
  demo: {
    seeVeviInAction: "See VEVI in Action",
    watchHowItWorks: "Watch how our AI voice replacement technology works",
    beforeEnglish: "Before (English)",
    originalPresentation: "Original corporate presentation",
    afterSpanish: "After (Spanish,French, Chinese, Italian)",
    aiTranslatedVoice: "AI-translated with natural voice",
    demoTitle: "Demo - VEVI in Action"
  },

  // Reviews
  reviews: {
    title: "What Our Customers Say",
    subtitle: "Trusted by marketing professionals worldwide",
    customerReviews: [
      {
        name: "Sarah Johnson",
        position: "Digital Marketing Manager",
        company: "TechFlow Solutions",
        text: "VEVI transformed our international marketing campaigns! We localized our product demo videos for 8 different markets in just one day. The quality is incredible and the pricing is so transparent."
      },
      {
        name: "Michael Chen",
        position: "Content Marketing Director", 
        company: "GlobalReach Media",
        text: "As someone who manages video content for multiple regions, VEVI is a game-changer. The voice replacement is so natural that our audiences can't tell it's AI-generated. Highly recommended!"
      },
      {
        name: "Emma Rodriguez",
        position: "Brand Marketing Specialist",
        company: "InnovateCorp",
        text: "We saved thousands on voice-over costs while expanding to new markets. The $0.0314 per second pricing is incredibly fair, and the results speak for themselves. Our conversion rates increased by 40%!"
      },
      {
        name: "David Thompson",
        position: "Marketing Campaign Manager",
        company: "NextGen Brands",
        text: "The speed and quality of VEVI is unmatched. We went from having one English video to 12 localized versions in different languages within hours. This tool is essential for global marketing."
      },
      {
        name: "Lisa Park",
        position: "Social Media Marketing Lead",
        company: "CreativeEdge Agency",
        text: "VEVI made it possible for our small agency to offer multilingual video services to clients. The quality is professional-grade and the process is incredibly simple. Our clients love the results!"
      },
      {
        name: "James Wilson",
        position: "Performance Marketing Director",
        company: "ScaleUp Ventures",
        text: "ROI is everything in performance marketing, and VEVI delivers. We reduced our video localization costs by 80% while improving turnaround time from weeks to hours. This tool pays for itself immediately."
      }
    ]
  },

  // Payment dialog
  payment: {
    title: "Conversion Payment",
    processingCost: "Processing Cost",
    duration: "Duration:",
    baseCost: "Base cost",
    discount: "Discount ({promoCode}):",
    discountAmount: "Discount amount:",
    total: "Total:",
    emailToReceiveResult: "Email to receive result",
    emailPlaceholder: "your-email@example.com",
    promoCode: "🎟️ Promo Code (optional)",
    promoCodePlaceholder: "Enter promo code",
    check: "Check",
    checking: "Checking...",
    addSubtitles: "Add subtitles to video",
    addSubtitlesDescription: "Generate and embed subtitles in the target language",
    highQualityTranslation: "• High-quality AI translation",
    originalVideoPreserved: "• Original video preserved",
    fastProcessing: "• Fast processing (typically 5-10 minutes)",
    resultWillBeSent: "• Result will be sent to the specified email",
    cancel: "Cancel",
    continue: "Continue",
    enterEmail: "Please enter your email",
    enterValidEmail: "Please enter a valid email address",
    enterPromoCode: "Please enter a promo code",
    invalidPromoCode: "Invalid promo code",
    validPromoCode: "Valid promo code! {discount}% discount applied"
  },

  // Progress dialog
  progress: {
    title: "Processing Video",
    uploadingVideo: "📤 Uploading video file...",
    uploadingAndExtracting: "🎬 Uploading and extracting audio",
    transcribingAndTranslating: "🗣️ Transcribing speech and translating", 
    synthesizingAudio: "🎵 Synthesizing new audio track",
    step: "Step:",
    error: "Error"
  },

  // Result dialog
  result: {
    title: "Complete! Your video has been processed",
    conversionCompleted: "Conversion completed successfully!",
    processedVideoDescription: "🎬 Your processed video with voice cloning",
    payAndDownload: "Pay and Download",
    videoNotAvailable: "Video not available",
    useDownloadButton: "Please use the download button below",
    downloadError: "Download Error"
  },

  // Email sent dialog
  emailSent: {
    title: "Video Sent! 🎉",
    videoOnWay: "The video is already on its way to your email 🙏❤️",
    checkInbox: "Check your inbox and spam folder. The processed video will arrive shortly!",
    whatsNext: "What's next?",
    checkEmail: "• Check your email ({email})",
    checkSpam: "• Look in spam/junk folder if not found",
    downloadAndEnjoy: "• Download and enjoy your dubbed video!",
    close: "Close",
    processAnotherVideo: "Process Another Video"
  },

  // Processing steps
  processingSteps: {
    uploading: "Uploading video...",
    extracting: "Extracting audio...",
    transcribing: "Transcribing speech...",
    translating: "Translating content...",
    synthesizing: "Synthesizing new voice...",
    rendering: "Rendering final video...",
    complete: "Processing complete!"
  },

  // Common
  common: {
    minutes: "minutes",
    seconds: "seconds",
    loading: "Loading...",
    error: "Error",
    success: "Success"
  },

  // Social media
  socialMedia: {
    title: "Stay Connected",
    description: "Get the latest updates on AI voice technology"
  },

  // Services (for Footer)
  services: {
    dubbing: "Dubbing",
    voiceClone: "Voice Clone Dubbing",
    newVoice: "New Voice Dubbing",
    multilingual: "Multilingual Dubbing",
    multiSpeaker: "Multi-Speaker Dubbing",
    subtitles: "Subtitles",
    subtitlesOnly: "Subtitles Only",
    multilingualSubtitles: "Multilingual Subtitles",
    subtitlesDescription: "Automatically generate accurate subtitles for any platform.",
    subtitlesPrice: "Processing cost: $0.01/sec",
    addSubtitles: "Add subtitles",
    needsTranslation: "Need translation?",
    translationLanguage: "Translation language"
  },

  // Footer
  footer: {
    legal: "Legal",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog
  blog: {
    title: "VEVI Monster Blog",
    subtitle: "History and mythology of the VEVI universe",
    readMore: "Read more",
    backToBlog: "Back to blog",
    articleNotFound: "Article not found",
    characteristics: "Characteristics",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi is a being born from the plasma vortices of Zera-13b. He is neither flesh nor metal—his body consists of vibrating particles held together by an electromagnetic field.",
        metadata: {
          "Galaxy": "MoM-z14",
          "Age": "13.4 billion years",
          "Type": "Rocky planet with a dense atmosphere of methane and neon",
          "Star": "Red protostar Zera-13",
          "Orbit": "Second planet in the system",
        },
        content: [
          "🌑 Description",
          "Zera-13b is an ancient and nearly forgotten world, born in an era when the Universe was just learning to shine.",
          "Its sky shimmers with dim green flames, and the dense atmosphere trembles from neon storms. The surface is a black-gray landscape covered with glassy craters where methane winds leave fiery traces in the air.",
          "Beneath the surface lie caves of frozen gas, where, according to legends, the first forms of energy capable of thought were born.",
          "👾 Vevi (Vevi Monster)",
          "Vevi is a being born from the plasma vortices of Zera-13b.",
          "He is neither flesh nor metal—his body consists of vibrating particles held together by an electromagnetic field.",
          "His eyes shine with the reflected light of star Zera-13, and his voice sounds like the whisper of neon wind.",
          "Vevi left his world when the protostar began to fade. He traveled through intergalactic voids, guided by the instinct to search for new energy.",
          "Now he wanders through worlds, carrying with him a particle of the primordial light of Zera-13b.",
          "The glow came from the planet",
          "He has no legs—because the planet has enormous gravity and he simply levitates",
          "He communicates (or rather makes sounds) similar to the acoustic waves of dolphins, whales, and orcas.",
          "His language is called UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub is a being from the early Universe, born in Sub Zone, a rare region of space with high matter density.",
        metadata: {
          "Object Name": "Sub Zone (SUB-Z)",
          "Object Type": "Protocluster / galaxy formation region",
          "Epoch": "~200–300 million years after the Big Bang",
          "Redshift": "z ≈ 14–15",
          "Right Ascension (RA)": "02h 17m 43s",
          "Declination (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Baddy Sub Data",
          "Long, thin, oblong body with two lower limbs at the bottom and three eyes on extended forms at the top",
          "He has no mouth.",
          "There are also two upper thin limbs that can be interpreted as arms.",
          "Two fingers on each limb.",
          "The entire body resembles a tree branch",
          "Skin has a smooth matte structure",
          "Color is greenish-brown (pigmentation)",
          "Can change color from surroundings like a chameleon.",
          "Description of the planet where Baddy Sub was born:",
          "Sub Zone is a rare region of the early Universe with high matter density, where the first galactic structures began to form. Observations indicate intense interactions of primordial gas, radiation, and gravitational waves. The region has recorded unstable signal patterns and anomalous resonant activity, uncharacteristic of typical protogalactic regions.",
          "Scientific Significance:",
          "Sub Zone is considered a key object for studying the early stages of galaxy assembly, signal propagation in the young Universe, and the transition from chaotic radiation fields to structured cosmic systems.",
          "Status:",
          "Classified as an unresolved formation region. Further research is required.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Everything you need to know about VEVI",
    questions: [
      {
        question: "Do you only work with voice?",
        answer: "Yes — we replace your voice so it sounds in another language while keeping it natural and authentic."
      },
      {
        question: "Do I pay before or after?",
        answer: "After. You hear the result first, then pay."
      },
      {
        question: "Refunds?",
        answer: "Not needed — you pay only once you're happy with the result."
      },
      {
        question: "Video longer than 5 minutes?",
        answer: "No problem. Ask our AI assistant in the online chat for instructions."
      },
      {
        question: "Can I choose another voice?",
        answer: "No — we only clone your own voice."
      },
      {
        question: "Minimum payment?",
        answer: "From $0.50."
      },
      {
        question: "How do I get my video?",
        answer: "Instant download in your browser + copy to your email after payment."
      },
      {
        question: "Discounts for large orders?",
        answer: "Yes — contact our AI assistant in the online chat."
      },
      {
        question: "Didn't find your answer?",
        answer: "Ask our AI assistant in the online chat — we're here to help."
      },
      {
        question: "Unsupported format?",
        answer: "Use a converter or get quick help from our AI assistant in the online chat."
      },
      {
        question: "My video includes specific terms that must be pronounced correctly. Can I control that?",
        answer: "Yes — just message our AI assistant in the online chat, and we'll send you instructions on how to mark or preserve certain terms (for example, leave them in English)."
      },
      {
        question: "I didn't receive my email. What should I do?",
        answer: "Processing time may vary due to queue volume. Don't worry — your file is safe. You'll receive either a notification or a direct download link once it's ready."
      }
    ]
  },

  // Pages
  pages: {
    privacy: {
      title: "VEVI MONSTER Privacy Policy",
      lastUpdated: "Last updated: December 12, 2025",
      interpretationAndDefinitions: "1. Interpretation and Definitions",
      interpretation: "Interpretation",
      interpretationDesc: "Words with capitalized initial letters have meanings defined below. These definitions apply regardless of whether they appear in singular or plural form.",
      definitions: "Definitions",
      definitionsDesc: "For the purposes of this Privacy Policy:",
      definitionsItems: [
        { term: "Account", definition: "means a unique account created for You to access Our Service or parts of Our Service." },
        { term: "Affiliate", definition: "means an entity that controls, is controlled by, or is under common control with a party, where \"control\" means ownership of 50% or more of the shares or voting rights." },
        { term: "Company", definition: "refers to General Secret OÜ, a private limited company registered in Estonia (registry code 17112803), with its principal office at Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Estonia." },
        { term: "Cookies", definition: "are small files placed on Your device that store information about Your browsing activity." },
        { term: "Country", definition: "refers to Estonia." },
        { term: "Device", definition: "means any device that can access the Service, such as a computer, smartphone, or tablet." },
        { term: "Personal Data", definition: "means any information relating to an identified or identifiable natural person." },
        { term: "Service", definition: "refers to the website operated by the Company: vevi.monster." },
        { term: "Service Provider", definition: "means any natural or legal person who processes data on behalf of the Company." },
        { term: "Usage Data", definition: "refers to data collected automatically through the use of the Service." },
        { term: "Website", definition: "refers to vevi.monster." },
        { term: "You", definition: "means the individual or legal entity accessing or using the Service." },
      ],
      scope: "2. Scope of This Privacy Policy",
      scopeDesc: "This Privacy Policy applies solely to Your use of vevi.monster. It does not apply to third-party websites or services that may be linked from Our Website. We have no control over, and assume no responsibility for, the privacy practices of third parties. We encourage You to review the privacy policies of any external websites You visit.",
      dataController: "3. Data Controller",
      dataControllerDesc: "For the purposes of the General Data Protection Regulation (GDPR), the Data Controller is:",
      companyName: "General Secret OÜ",
      companyAddress: "Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Estonia",
      dataControllerEmail: "Email: site@vevi.monster",
      collectingAndUsing: "4. Collecting and Using Your Personal Data",
      typesOfDataCollected: "4.1 Types of Data Collected",
      personalData: "Personal Data",
      personalDataDesc: "While using Our Service, We may ask You to provide certain personally identifiable information, including:",
      personalDataItems: ["Email address"],
      usageData: "Usage Data",
      usageDataDesc: "Usage Data is collected automatically and may include information such as:",
      usageDataItems: [
        "IP address",
        "Browser type and version",
        "Device information",
        "Pages visited and time spent on pages",
        "Date and time of visits",
        "Approximate location (city-level)",
      ],
      purposesAndLegalBasis: "5. Purposes and Legal Basis for Processing",
      purposesAndLegalBasisDesc: "We process Personal Data for the following purposes:",
      purposesAndLegalBasisItems: [
        "To provide and maintain the Service",
        "To manage user accounts",
        "To perform and manage contracts",
        "To contact You regarding service-related communications",
        "To send newsletters or marketing communications (where consent is provided)",
        "To manage user inquiries and requests",
        "To analyze usage and improve the Service",
        "To comply with legal obligations",
      ],
      purposesAndLegalBasisLegalBases: "Legal bases for processing may include consent, contractual necessity, legal obligations, and legitimate interests in accordance with GDPR.",
      thirdPartyServices: "6. Third-Party Services",
      analytics: "6.1 Analytics",
      googleAnalytics: "Google Analytics 4 (Google Ireland Limited)",
      googleAnalyticsDesc: "Used to analyze traffic and usage behavior.",
      googleAnalyticsData: "Personal Data processed: browser information, city, device information, approximate location, session statistics",
      googleAnalyticsPlace: "Place of processing: Ireland",
      googleAnalyticsOptOut: "Users may opt out via Google's opt-out mechanisms.",
      advertising: "6.2 Advertising",
      googleAdManager: "Google Ad Manager (Google Ireland Limited)",
      googleAdManagerDesc: "Used to display advertising content.",
      googleAdManagerData: "Personal Data processed: Cookies, Trackers, Usage Data",
      googleAdManagerPlace: "Place of processing: Ireland",
      googleAdManagerSettings: "Users can manage ad preferences through Google Ad Settings.",
      payments: "6.3 Payments",
      paymentsDesc: "Payment processing services allow Us to process payments securely. We do not store full payment card details.",
      stripe: "Stripe",
      stripeDesc: "Payment processing provider.",
      stripeData: "Personal Data processed: various types of data as defined by Stripe's privacy policy",
      stripePlace: "Place of processing: United States and other jurisdictions",
      revolut: "Revolut Payments",
      revolutDesc: "Payment services provided by Revolut entities within the European Union.",
      revolutData: "Personal Data processed: payment and identification data as required for transaction processing",
      revolutPlace: "Place of processing: European Union",
      cookiesAndTracking: "7. Cookies and Tracking Technologies",
      cookiesAndTrackingDesc: "We use Cookies and similar tracking technologies to monitor activity and improve the Service. Cookies: small data files stored in Your browser. Trackers: cookies, web beacons, scripts, and similar technologies. You can control Cookies through Your browser settings.",
      sharingOfData: "8. Sharing of Your Personal Data",
      sharingOfDataDesc1: "We do not sell Your Personal Data.",
      sharingOfDataDesc2: "We may share Your data:",
      sharingOfDataItems: [
        "With Service Providers acting on Our behalf",
        "To comply with legal obligations",
        "In connection with business transfers (e.g., merger or acquisition)",
        "In anonymized, aggregated form for analytics or business insights",
      ],
      sharingOfDataDesc3: "All third parties are required to process Personal Data securely and in compliance with applicable laws.",
      dataRetention: "9. Data Retention",
      dataRetentionDesc: "We retain Personal Data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, including compliance with legal, accounting, or reporting requirements. Usage Data is generally retained for a shorter period unless required for security or legal purposes.",
      internationalTransfers: "10. International Data Transfers",
      internationalTransfersDesc: "Your Personal Data may be processed outside Your country of residence. We ensure that appropriate safeguards are in place to protect Your data, in accordance with GDPR requirements. By using the Service, You consent to such transfers.",
      yourRightsGDPR: "11. Your Rights Under GDPR",
      yourRightsGDPRDesc: "You have the right to:",
      yourRightsGDPRItems: [
        "Access Your Personal Data",
        "Rectify inaccurate data",
        "Request deletion of Your data",
        "Restrict or object to processing",
        "Data portability",
        "Withdraw consent at any time",
      ],
      yourRightsGDPRContact: "To exercise Your rights, please contact Us at site@vevi.monster.",
      deletionOfData: "12. Deletion of Personal Data",
      deletionOfDataDesc: "You may request deletion of Your Personal Data at any time. Certain data may be retained if required by law or for legitimate business purposes.",
      disclosureOfData: "13. Disclosure of Personal Data",
      disclosureOfDataDesc: "We may disclose Personal Data:",
      disclosureOfDataItems: [
        "To comply with legal obligations",
        "To protect the Company's rights or property",
        "To prevent or investigate wrongdoing",
        "To protect the safety of Users or the public",
      ],
      securityOfData: "14. Security of Your Personal Data",
      securityOfDataDesc: "We implement appropriate technical and organizational measures to protect Personal Data. However, no method of transmission over the Internet is completely secure.",
      childrenPrivacy: "15. Children's Privacy",
      childrenPrivacyDesc: "Our Service is not intended for children under the age of 13. We do not knowingly collect Personal Data from children. If You believe a child has provided Us with Personal Data, please contact Us.",
      linksToOtherWebsites: "16. Links to Other Websites",
      linksToOtherWebsitesDesc: "Our Service may contain links to third-party websites. We are not responsible for their content or privacy practices.",
      changesToPolicy: "17. Changes to This Privacy Policy",
      changesToPolicyDesc: "We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.",
      contactUs: "18. Contact Us",
      contactUsDesc: "If You have any questions about this Privacy Policy or Our data practices, please contact Us:",
      contactEmail: "Email: site@vevi.monster",
      contactCompany: "Company: General Secret OÜ",
      contactAddress: "Address: Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Estonia",
    },
    terms: {
      title: "VEVI MONSTER Terms of Service",
      lastUpdated: "Last updated: December 12, 2025",
      definitions: "1. Definitions",
      definitionsItems: [
        { term: "Account", definition: "A unique account created for You to access the Service." },
        { term: "Content", definition: "Any text, images, audio, video, or other materials uploaded, submitted, or otherwise made available via the Service." },
        { term: "Deliverables", definition: "Results of services performed under agreements with Us, including final audio, video, or other creative outputs." },
        { term: "User", definition: "The individual or entity accessing or using the Service." },
        { term: "You", definition: "The User." },
        { term: "Service Provider", definition: "Third-party companies or individuals assisting Us in delivering the Service." },
      ],
      useOfService: "2. Use of the Service",
      useOfService21: "2.1. You agree to use the Service only for lawful purposes.",
      useOfService22: "2.2. You shall not upload, post, or transmit any content that is unlawful, harmful, offensive, or infringes on any third-party rights.",
      useOfService23: "2.3. The Service may include links to third-party websites. We are not responsible for the content or practices of these third parties.",
      accountRegistration: "3. Account Registration",
      accountRegistration31: "3.1. You may be required to create an Account to access certain features of the Service.",
      accountRegistration32: "3.2. You are responsible for maintaining the confidentiality of Your Account credentials and for all activities under Your Account.",
      accountRegistration33: "3.3. You must notify Us immediately of any unauthorized use of Your Account.",
      paymentAndSubscriptions: "4. Payment and Subscriptions",
      paymentAndSubscriptions41: "4.1. Some services may require payment. All fees are specified at the time of purchase.",
      paymentAndSubscriptions42: "4.2. Payments are processed securely through third-party providers (e.g., Stripe, Revolut).",
      paymentAndSubscriptions43: "4.3. You agree to provide accurate billing information and pay all charges incurred.",
      paymentAndSubscriptions44: "4.4. Refunds, if any, are governed by the Service-specific policies provided at the time of purchase.",
      intellectualPropertyRights: "5. Intellectual Property Rights",
      intellectualPropertyRights51: "5.1. All Deliverables created by the Company for You become Your exclusive property upon acceptance and payment.",
      intellectualPropertyRights52: "5.2. To the fullest extent allowed by applicable law, the Company hereby transfers and assigns to You all economic copyrights in the Deliverables worldwide, for the duration of copyright protection, covering all known fields of exploitation including but not limited to:",
      intellectualPropertyRights52Items: [
        "Reproduction, distribution, and display;",
        "Public dissemination via the Internet, social media, streaming or VOD platforms;",
        "Creation of derivative works;",
        "Commercial use, lending, or rental.",
      ],
      intellectualPropertyRights53: "5.3. To the extent permitted by law, the Company will not exercise moral rights that would interfere with Your use of the Deliverables.",
      intellectualPropertyRights54: "5.4. If Deliverables are not eligible for copyright protection (e.g., AI-generated), You receive an unrestricted, perpetual, worldwide, irrevocable right to use, modify, and exploit them in any way without further claims.",
      userContent: "6. User Content",
      userContent61: "6.1. You retain ownership of any content You upload to the Service but grant Us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display it for the purpose of providing the Service.",
      userContent62: "6.2. You represent and warrant that You have all necessary rights to upload content and that it does not infringe any third-party rights.",
      privacy: "7. Privacy",
      privacyDesc: "Your use of the Service is also governed by Our Privacy Policy, which describes how We collect and process Personal Data.",
      termination: "8. Termination",
      termination81: "8.1. We may suspend or terminate Your Account if You breach these Terms.",
      termination82: "8.2. You may terminate Your Account at any time by contacting Us.",
      limitationOfLiability: "9. Limitation of Liability",
      limitationOfLiability91: "9.1. The Service is provided \"as is\" and \"as available.\"",
      limitationOfLiability92: "9.2. To the fullest extent permitted by law, the Company is not liable for any indirect, incidental, or consequential damages arising from the use of the Service.",
      indemnification: "10. Indemnification",
      indemnificationDesc: "You agree to indemnify, defend, and hold harmless the Company, its affiliates, and Service Providers from any claims, damages, liabilities, or expenses arising out of Your use of the Service or violation of these Terms.",
      governingLaw: "11. Governing Law",
      governingLawDesc: "These Terms are governed by the laws of Estonia, without regard to its conflict of laws principles.",
      changesToTerms: "12. Changes to Terms",
      changesToTermsDesc: "We may update these Terms from time to time. Changes will be posted on this page with the updated revision date.",
      contactInformation: "13. Contact Information",
      contactInformationDesc: "",
      companyName: "Company: General Secret OÜ",
      companyAddress: "Address: Vesivärava tn 50-201, Kesklinna linnaosa, Tallinn, Harju maakond, 10152, Estonia",
      contactEmail: "Email: site@vevi.monster",
    },
  },
};

export type TranslationKeys = typeof en;
